import type { JSX } from "react";

import { ContextMenu as BaseContextMenu } from "@base-ui/react/context-menu";
import { useFloatingPortalContainer } from "@frontend/contexts";

import type { ContextMenuPortalProps } from "./ContextMenu.types";

export function ContextMenuPortal({
  children,
  ...props
}: ContextMenuPortalProps): JSX.Element {
  const container = useFloatingPortalContainer();

  return (
    <BaseContextMenu.Portal
      data-slot="context-menu-portal"
      container={container}
      {...props}
    >
      {children}
    </BaseContextMenu.Portal>
  );
}
